import { MOCK_MODE } from '../lib/api';

/** Permanent badge shown whenever VITE_MOCK=1, per the task brief. */
export function MockBadge() {
  if (!MOCK_MODE) return null;
  return (
    <span className="px-2.5 py-1 rounded-full border border-dashed border-zinc-400 text-muted text-xs">
      Sample data
    </span>
  );
}
